



































import { Component, Prop, Vue } from 'vue-property-decorator';
import BasicBadge from '@/components/BasicBadge.vue';

@Component({ components: { BasicBadge } })
export default class ConversationHeader extends Vue {
  @Prop() readonly activeConversations!: number|string
}
